const factory = ({ application, eventLog, passphraseCache }) => {
    const restoreFromCurrentPhrase = async ({ passphrase } = {}) => {
        await eventLog.record({ event: 'restore_with_current_phrase' });
        if (!passphrase && passphraseCache)
            passphrase = await passphraseCache.get();
        const mnemonic = await application.getMnemonic({ passphrase });
        await application.import({ passphrase, mnemonic });
    };
    return {
        application: {
            start: application.start,
            stop: application.stop,
            load: application.load,
            unload: application.unload,
            create: application.create,
            lock: application.lock,
            unlock: application.unlock,
            import: application.import,
            restart: application.restart,
            delete: application.delete,
            getMnemonic: application.getMnemonic,
            setBackedUp: application.setBackedUp,
            changePassphrase: application.changePassphrase,
            changeLockTimer: application.changeLockTimer,
            restartAutoLockTimer: application.restartAutoLockTimer,
            restoreFromCurrentPhrase,
        },
    };
};
const applicationApiDefinition = {
    id: 'applicationApi',
    type: 'api',
    factory,
    dependencies: ['application', 'eventLog', 'passphraseCache?'],
};
export default applicationApiDefinition;
